module.exports = __webpack_public_path__ + "img/web1.95fabc85.png";